export enum FixtureStatuses {
  Abandoned = "ABANDONED",
  AboutToStart = "ABOUT_TO_START",
  Bye = "BYE",
  Cancelled = "CANCELLED",
  Confirmed = "CONFIRMED",
  Draft = "DRAFT",
  Finished = "FINISHED",
  IfNeeded = "IF_NEEDED",
  InProgress = "IN_PROGRESS",
  OnPitch = "ON_PITCH",
  Pending = "PENDING",
  Postponed = "POSTPONED",
  Scheduled = "SCHEDULED",
  WarmUp = "WARM_UP",
}
